import {GamblingWarningDefaultBox} from "./gambling-warning.default.box";

export const GamblingWarningBox = GamblingWarningDefaultBox;
